const adminLibraryRouter = [
  {
    path: '/admin/library',
    name: 'AdminLibraryIndex',
    component: () => import('@/views/admin/library/index')
  },
  {
    path: '/admin/library/create',
    name: 'AdminLibraryCreate',
    component: () => import('@/views/admin/library/create')
  },
  {
    path: '/admin/library/edit',
    name: 'AdminLibraryEdit',
    component: () => import('@/views/admin/library/edit')
  },
  {
    path: '/admin/library/link',
    name: 'AdminLibraryLink',
    component: () => import('@/views/admin/library/link')
  },
  {
    path: '/admin/library/stat',
    name: 'AdminLibraryStat',
    component: () => import('@/views/admin/library/stat')
  }
]

export default adminLibraryRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/library.js